<div class="screen-wrapper">
  <div class="inner-wrapper">
    <div class="left-panel" [class.collapsed]="isSidebarCollapsed">
      <!-- Sidebar Header with Branding -->
      <div class="sidebar-header">
        <div class="sidebar-brand" *ngIf="!isSidebarCollapsed">
          <!-- <svg-icon src="assets/icons/deo-agent-icon.svg" svgClass="brand-icon" /> -->
          <span class="brand-text" [title]="projectName">{{ projectName }}</span>
        </div>
        <button nz-button nzType="text" class="sidebar-toggle-btn" (click)="toggleSidebar()" title="Collapse sidebar" *ngIf="!isSidebarCollapsed">
          <svg-icon src="assets/icons/sidebar-left.svg" svgClass="sidebar-toggle-icon" />
        </button>
        <button nz-button nzType="text" class="sidebar-toggle-btn" (click)="toggleSidebar()" title="Expand sidebar" *ngIf="isSidebarCollapsed">
          <svg-icon src="assets/icons/sidebar-right.svg" svgClass="sidebar-toggle-icon" />
        </button>
      </div>
      <div class="project-meta-temp" [class.meta-collapsed]="isSidebarCollapsed">
        <div class="meta-stats-row">
          <span class="meta-item">
            <svg-icon src="assets/icons/chat.svg" class="meta-icon" />
            {{ projectChatsCount }} chat{{ projectChatsCount === 1 ? '' : 's' }}
          </span>
          <span class="meta-separator">&middot;</span>
          <span class="meta-item">
            <svg-icon src="assets/icons/files-content.svg" class="meta-icon" />
            {{ projectArtifactsCount }} artifact{{ projectArtifactsCount === 1 ? '' : 's' }}
          </span>
        </div>
        <div class="meta-updated">Updated {{ projectUpdatedLabel }}</div>
      </div>

      <!-- New Chat Button -->
      <div class="new-chat-section">
        <button nz-button nzType="default" (click)="createNewChat()" class="new-chat-btn">
          <svg-icon src="assets/icons/plus.svg" svgClass="plus-icon" />
          <span *ngIf="!isSidebarCollapsed">New Chat</span>
        </button>
      </div>

      <!-- Navigation Menu -->
      <div class="sidebar-nav">
        <div
          class="nav-item"
          *ngIf="isProjectInstructionsEnabled"
          [class.active]="activeTab === 'instructions'"
          (click)="changeActiveTab('instructions')"
          tabindex="0"
          (keydown.enter)="changeActiveTab('instructions')"
        >
          <div class="nav-icon-left">
            <svg-icon src="assets/icons/instructions.svg" class="nav-icon" />
            <span *ngIf="!isSidebarCollapsed">Instructions</span>
          </div>
          <svg-icon *ngIf="!isSidebarCollapsed" src="assets/icons/arrow-right.svg" class="nav-icon nav-icon-right" />
        </div>
        <div class="nav-item" [class.active]="activeTab === 'chats'" (click)="changeActiveTab('chats')" tabindex="0" (keydown.enter)="changeActiveTab('chats')">
          <div class="nav-icon-left">
            <svg-icon src="assets/icons/chat.svg" class="nav-icon" />
            <span *ngIf="!isSidebarCollapsed">Chats</span>
          </div>
          <svg-icon *ngIf="!isSidebarCollapsed" src="assets/icons/arrow-right.svg" class="nav-icon nav-icon-right" />
        </div>
        <div class="nav-item" [class.active]="activeTab === 'artifacts'" (click)="changeActiveTab('artifacts')" tabindex="0" (keydown.enter)="changeActiveTab('artifacts')">
          <div class="nav-icon-left">
            <svg-icon src="assets/icons/files-content.svg" class="nav-icon" />
            <span *ngIf="!isSidebarCollapsed">Artifacts</span>
          </div>
          <svg-icon *ngIf="!isSidebarCollapsed" src="assets/icons/arrow-right.svg" class="nav-icon nav-icon-right" />
        </div>
      </div>

      <!-- Chat Sessions List (shown when no active tab or chats tab) -->
      <deo-ai-recent-starred-chat-section
        *ngIf="!isSidebarCollapsed"
        [starredSessions]="starredSessions"
        [recentSessions]="recentSessions"
        [currentSessionId]="currentSessionId"
        [isProjectView]="true"
        (chatSelected)="selectChat($event)"
        (chatDeleted$)="onChatDeleted($event)"
        (chatRemovedFromProject$)="onChatRemovedFromProject($event)"
      ></deo-ai-recent-starred-chat-section>
    </div>
    <div class="right-panel">
      <!-- Main Chat Area -->
      <div class="chat-main">
        <!-- Welcome Screen (shown when no messages) -->
        <deo-ai-assistant-welcome-screen
          *ngIf="activeTab === 'welcome'"
          [userName]="userName"
          [(currentMessage)]="currentMessage"
          [selectedFile]="selectedFile"
          [isLoading]="isLoading"
          [isTyping]="isTyping"
          [isListening]="isListening"
          [beforeUpload]="beforeUpload"
          (send)="onWelcomeScreenSend($event)"
        ></deo-ai-assistant-welcome-screen>

        <!-- Existing Chat Interface (shown when messages exist) -->
        <deo-ai-assistant-chats-view
          *ngIf="activeTab === 'chats'"
          [allChats]="chatSessions"
          [currentSessionId]="currentSessionId"
          [isProjectView]="true"
          (createNewChatRequested)="createNewChat()"
          (chatSelected)="selectChat($event)"
          (chatDeleted$)="onChatsDeleted($event)"
          (chatRemovedFromProject$)="onChatRemovedFromProject($event)"
        >
        </deo-ai-assistant-chats-view>

        <deo-ai-assistant-existing-chat
          *ngIf="activeTab === 'one-chat'"
          [conversation]="currentConversation"
          [currentSessionId]="currentSessionId"
          [chatTitle]="currentChatTitle"
          [isFavorite]="isCurrentChatFavorite()"
          [isReadOnly]="isCurrentChatReadOnly"
          [ownerLabel]="currentChatOwner"
          (favoriteChanged)="onCurrentChatFavoriteChanged($event)"
          (chatDeleted$)="onChatDeleted($event)"
        ></deo-ai-assistant-existing-chat>

        <div class="instructions-area" *ngIf="activeTab === 'instructions'">
          <deo-project-instructions
            [projectId]="projectId"
            [projectName]="projectName"
            [canEdit]="isProjectOwner"
            (loadingChange$)="onRightPanelLoadingChange($event)"
            (instructionsSaved$)="onInstructionsSaved()"
          ></deo-project-instructions>
        </div>

        <div class="artifacts-area" *ngIf="activeTab === 'artifacts'">
          <deo-artifacts [projectId]="projectId" (loadingChange)="onRightPanelLoadingChange($event)" (artifactsDeleted$)="onArtifactsDeleted($event)"></deo-artifacts>
        </div>

        <div class="right-panel-loader" *ngIf="shouldShowRightPanelSpinner()">
          <gains-spinner></gains-spinner>
        </div>
      </div>
    </div>
  </div>
</div>

<deo-view-artifact-drawer></deo-view-artifact-drawer>
